(ns ui.components.search-selector.components.result
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.view.components.power-search.highlight.view :as highlight]
   [ui.util :as uu]
   [ui.components.button.view :as button]))

(defn result
  [{:keys [tab-index hit active?
           on-click]}]
  (let [{:keys [title id]} hit]
    ^{:key (str id)}
    [:div
     {:id          (string/join "_"
                                ["universal-search-result-hit"
                                 (-> hit
                                     :_source
                                     :original
                                     :entity/type)
                                 (:_id hit)])
      :class       (uu/cm
                    "flex hover:text-base-light-text-accent"
                    (when (fn? on-click)
                      "cursor-pointer"))
      :style       {:background
                    (when active? "#fafafa")}
      :tab-index   tab-index
      ;;:on-focus    (fn [] (reset! focused-state true))
      ;;:on-blur     (fn [] (reset! focused-state false))
      :on-key-down (fn [e] (when (= "Enter" (.-key e)) (.stopPropagation e)))
      :on-click    (when (fn? on-click)
                     (fn [_e]
                       (on-click id)))}
     [:div
      [:div
       (let [name-highlight-text (-> hit
                                     :highlight
                                     (select-keys [:extras.lower-case-display-name])
                                     (vals)
                                     (ffirst))]
         title
         ;;(if name-highlight-text
         ;;  [highlight/highlight name-highlight-text]
         ;;  (cos/hit->entity-name hit))
         )]

      ;; (when (and (session/show-experimental-ribbon-features?)
      ;;            (= entity-type :entity.type/company))
      ;;   [experimental-open-in-ribbon-tab-button props])

      ;;TODO highlights from outside
      #_(let [highlight (-> hit
                          :highlight
                          (dissoc :extras.lower-case-display-name))
            [dot-separated-field-path [highlight-text]]
            (->> highlight
;;                 (remove
;;                  (comp cos/dot-separated-entity-name-path? first))
                 (sort-by
                  (comp highlight/highlighted-parts-total-length second))
                 (first))]
        (when highlight-text
          [:div
           [:div
            ;;(cos/dot-separated-path->field-name dot-separated-field-path)
            ":"]
           [:div
            [highlight/highlight highlight-text]]]))]]))

(defn result-group
  [{:keys [icon-class title active-id visible-hits section-index
           on-result-click]}]
  [:div
   {:class "flex flex-col gap-2"}
   [:div
    {:class "flex gap-3 justify-between items-center"}
    [:div
     {:class "flex items-center gap-2"}
     [:span
      {:class "flex w-8 h-8 justify-center items-center rounded-full bg-complement-regular"}
      [:i
       {:class (uu/cm "inline-block text-md fal"
                      icon-class)}]]
     [:b title]]
    ;; TODO pass this component(/hiccup) as param(?):
    #_(when more?
        [:div
         {:class "*:p-0"}
         [button/primary-open
          {:tab-index   -1
           :on-key-down (fn [e] (when (= "Enter" (dg/event-key e))
                                  (dg/stop-propagation e)))
           :on-click    (fn []
                          (let [dom-input (dg/element-by-id "universalSearchInput")]
                            (if dom-input
                              (.focus dom-input)
                              (js/console.log "Cannot find universal search input!"))
                            (rf/dispatch ;;[::event/open-type-view entity-type]
                             )))}
          (str (loc/tr :show-only-entity-type)
               (string/lower-case entity-type-display-name))]])]
   [:<>
    [:div
     {:class "flex flex-col gap-2 pl-8"}
     (->> visible-hits
          (map-indexed
           (fn [hit-index {:keys [id] :as hit}]
             ^{:key (str id)}
             [result
              {:hit       hit
               :tab-index (-> section-index
                              (* 100)
                              (+ hit-index)
                              (+ 1000))
               :active? (= id active-id)
               :on-click on-result-click}])))]
    ;;TODO pass this hiccup as param
    #_(when can-load-more?
        [button/secondary-open
         {:tab-index   (-> section-index
                           (* 100)
                           (+ (count visible-hits))
                           (+ 1000))
          :on-key-down (fn [e] (when (= "Enter" (dg/event-key e))
                                 (dg/stop-propagation e)))
          :on-click    (fn []
                       ;;(rf/dispatch [::event/load-more])
                         )}
         (loc/tr :load-more)])]])
